import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeArr, judgeObj } from '@/shared/functions';
const initState = {
    options: [],
    notNeedOptions: [],
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 获取要展示的列的字段
         */
        queryShowColumn(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 租户code 类型 type 类型
                const { typeId, notArr, originalArr } = payload;
                const _param = { tenantCode: rootState.userInfo.user.tenantCode || '', typeId };
                let _r1 = [];
                let _r2 = [];
                let _r3 = [];
                return Api.uniApi.getFieldConfigList(_param).then((res) => {
                    if (!(judgeObj(res) && judgeObj(res.data))) {
                        return;
                    }
                    const data = JSON.parse(JSON.stringify(res.data.data));
                    if (judgeArr(data)) {
                        _r1 = data;
                        _r3 = _r1;
                        // 更换name
                        if (judgeArr(originalArr)) {
                            _r1 = _r1.map((_item) => {
                                const _i = originalArr.findIndex((_item2) => (_item2.dataIndex === _item.code));
                                _i === -1 ? '' : _item.name = originalArr[_i].title;
                                return _item;
                            });
                            _r3 = _r1;
                        }
                        if (judgeArr(notArr)) {
                            // 该状态下，可以选择的列
                            _r3 = _r1.filter((_item) => {
                                return notArr.findIndex((_item2) => (_item2 === _item.code)) === -1;
                            });
                            // 该状态下，不需要的列
                            _r2 = _r1.filter((_item) => {
                                return notArr.findIndex((_item2) => (_item2 === _item.code)) !== -1;
                            });
                        }
                    }
                    return _r3;
                }).catch((err) => {
                    console.log(err);
                    return _r3;
                }).finally(() => {
                    this.SET_STATE({
                        options: _r3,
                        notNeedOptions: _r2,
                    });
                });
            });
        },
        /**
         * @desc 保存要展示的列的字段
         */
        saveShowColumn(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 租户code 类型 type 类型 [{code, isView}]
                const { typeId, arr } = payload;
                const _param = { tenantCode: rootState.userInfo.user.tenantCode || '', typeId, fieldConfigList: arr };
                return Api.uniApi.saveFieldConfigList(_param).then((res) => {
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
    },
});
